/*=========================================================================================
  File Name: moduleUserFileActions.js
  Description: Admin Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
    updateUserFileDownloadCount({ commit }, userFileInfo) {
        return new Promise((resolve, reject) => {
            axios.put(`/api/user-file-management/user-file`, userFileInfo)
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
}